import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["value", "spinButtonsDisabled"];
import * as React from 'react';
import { useStyles, StyleSheet } from '@rexlabs/styling';
import TextInput from './text-input';
var defaultStyles = StyleSheet({
  spinButtons: {
    MozAppearance: 'textfield',
    '&::-webkit-inner-spin-button, &::-webkit-outer-spin-button': {
      display: 'none'
    }
  }
});
export var NumberInput = /*#__PURE__*/React.forwardRef(function NumberInput(_ref, ref) {
  var value = _ref.value,
      _ref$spinButtonsDisab = _ref.spinButtonsDisabled,
      spinButtonsDisabled = _ref$spinButtonsDisab === void 0 ? true : _ref$spinButtonsDisab,
      props = _objectWithoutProperties(_ref, _excluded);

  var s = useStyles(defaultStyles);
  return /*#__PURE__*/React.createElement(TextInput, _extends({}, s({
    spinButtons: spinButtonsDisabled
  }), {
    placeholder: "0",
    step: 1
  }, props, {
    ref: ref,
    type: "number" // we cast the number to string like this because if we actually convert it to a string via the String() constructor, it will lose decimal precision in some cases
    ,
    value: value
  }));
});
export default NumberInput;